import browserUtil from './BrowserUtil';

let localeKeysToDelete = [];

const loadLocales = (key) => {
	if(key && window[key.toLowerCase()]){
		localeKeysToDelete.push(key.toLowerCase());
		return window[key.toLowerCase()];
	}	
	return window.en_us;
}

const en_US = loadLocales("en_US");
const ta_IN = loadLocales("ta_IN");
const hi_IN = loadLocales("hi_IN");
const ml_IN = loadLocales("ml_IN");
const ms_mly = loadLocales("ms_mly");
const te_IN = loadLocales("te_IN");
const zh_CN = loadLocales("zh_CN");
const zh_TW = loadLocales("zh_TW");
const id_indo = loadLocales("id_indo");
const en_ZA = loadLocales("en_ZA");

//console.log("lalala to deelete ::", localeKeysToDelete);
if(localeKeysToDelete && localeKeysToDelete.length > 0){
	localeKeysToDelete.map((elem, index) => {
		window[elem] = null;
	});
}


const RbUtil = function(){

	const ALL_LOCALES = ["en_us","hi_in","ml_in","ms_mly","ta_in","te_in","zh_cn","zh_tw","id_indo","en_za"];

	//Setting defaultLocale to en_US
	var defaultLocale = "en_US";

	//Setting userLocale to en_US unless otherwise changed by the user
	var userLocale = "en_US";

	const getGeo = function(){
		if(sessionStorage.getItem("geo") && sessionStorage.getItem("geo").length > 0){
			return sessionStorage.getItem("geo");
		}

		return browserUtil.getCookie("geo");
	}

	var getBundle = function(locale){

		locale = (getGeo()) ? locale + "_" + getGeo().toLowerCase() : locale;
		locale = (typeof locale === "string") ? locale.toLowerCase() : locale;

		switch(locale){
			case "en_us" : return en_US;
			case "hi_in" : return hi_IN;
			case "ml_in" : return ml_IN;
			case "ms_mly" : return ms_mly;
			case "ta_in" : return ta_IN;
			case "te_in" : return te_IN;
			case "zh_cn" : return zh_CN;
			case "zh_tw" : return zh_TW;
			case "id_indo" : return id_indo;
			case "en_za" : return en_ZA;
			default: return en_US;
		}
	}
	var replaceDynamicText = function(originalString,replaceStringArray)
	{
		for(var i=0;i<replaceStringArray.length;i++)
		{
		   var val = "{"+i+"}";
		   originalString = originalString.split(val).join(replaceStringArray[i]);
		}
		return originalString;
	}
	return {
		getText:function(rawTxt,replaceStringArray=[]){
			try{
				var rb = getBundle(userLocale);
				if(rb[rawTxt]){
					return (replaceStringArray.length>0) ? replaceDynamicText(rb[rawTxt],replaceStringArray) : rb[rawTxt];
				}
				else if(getBundle(defaultLocale)[rawTxt]){
					return (replaceStringArray.length>0) ? replaceDynamicText(getBundle(defaultLocale)[rawTxt],replaceStringArray) : getBundle(defaultLocale)[rawTxt];
				}
			}catch(e){
				console.error(e);
			}

			return (replaceStringArray.length>0) ? replaceDynamicText(rawTxt,replaceStringArray) : rawTxt;
		},
		setLocale:function(locale){
			userLocale = locale;
		},
		getLocale:function(){
			return userLocale;
		},
		getLocales:function(){
			return ALL_LOCALES;
		}
	}
}();

export default RbUtil;


// WEBPACK FOOTER //
// ./src/util/RbUtil.js